import { Button } from './ui/button';
import { PhoneCall, FileText } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { homeTranslations } from '../translations/home';

const HeroSection = () => {
  const { language } = useLanguage();
  const t = homeTranslations[language].hero;

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="/images/home/hero.jpg"
          alt="DSI Industrial Facilities"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/85 to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center md:text-left">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center px-4 py-2 bg-[#B91C1C]/20 border border-[#B91C1C]/50 rounded-full mb-6 backdrop-blur-sm">
            <span className="text-[#B91C1C] text-sm font-semibold">{t.badge}</span>
          </div>

          {/* Main Title */}
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
            {t.title1}{' '}
            <span className="text-[#B91C1C]">{t.titleCNC}</span>,{' '}
            <span className="text-[#B91C1C]">{t.titleHarness}</span>,{' '}
            {t.titleAnd} <span className="text-[#B91C1C]">{t.titleAuto}</span>
          </h1>

          {/* Subtitle */}
          <p className="text-xl md:text-2xl text-gray-300 mb-10 leading-relaxed">
            {t.subtitle}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Button 
              size="lg"
              className="bg-[#B91C1C] hover:bg-[#991B1B] text-white px-8 py-6 text-lg font-semibold  shadow-lg shadow-[#B91C1C]/30"
              onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            >
              <FileText className="mr-2" size={20} />
              {t.cta1}
            </Button>
          </div>

          {/* Trust Indicators */}
          <div className="mt-12 flex flex-wrap gap-8 text-gray-400 text-sm">
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-[#B91C1C] rounded-full"></div>
              <span>{t.trust1}</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-[#B91C1C] rounded-full"></div>
              <span>{t.trust2}</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-[#B91C1C] rounded-full"></div>
              <span>{t.trust3}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <div className="w-6 h-10 border-2 border-gray-400 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-2 bg-[#B91C1C] rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
